interface SecretLoginLinkDialogProps {
  url: string
  targetName?: string
  expiresAt?: string
  onClose: () => void
}

function formatExpiresAt(value?: string): string {
  if (!value) return '15 минут'
  try {
    return new Date(value).toLocaleString('ru-RU')
  } catch {
    return value
  }
}

export function SecretLoginLinkDialog({ url, targetName, expiresAt, onClose }: SecretLoginLinkDialogProps) {
  async function copyLink() {
    await navigator.clipboard.writeText(url)
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/45 px-4" onClick={onClose}>
      <div
        className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-sky-600">Secret вход в ЛК пациента</p>
            <h3 className="mt-1 text-lg font-semibold text-slate-900">
              Ссылка для пациента{targetName ? `: ${targetName}` : ''}
            </h3>
            <p className="mt-1 text-sm text-slate-500">
              Отправьте пациенту эту ссылку. Она временная, действует до {formatExpiresAt(expiresAt)}.
            </p>
          </div>
          <button
            type="button"
            className="rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
            onClick={onClose}
            aria-label="Закрыть"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <label className="block text-xs font-medium uppercase tracking-wide text-slate-500">Ссылка для копирования</label>
        <textarea
          className="mt-2 h-28 w-full resize-none rounded-xl border border-slate-300 bg-slate-50 px-3 py-2 text-xs font-mono text-slate-700"
          value={url}
          readOnly
          onFocus={(event) => event.currentTarget.select()}
        />

        <div className="mt-4 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
          >
            Открыть
          </button>
          <button
            type="button"
            className="rounded-lg bg-sky-600 px-3 py-2 text-sm font-medium text-white hover:bg-sky-700"
            onClick={() => void copyLink()}
          >
            Скопировать ссылку
          </button>
        </div>
      </div>
    </div>
  )
}
